export default function (value) {
    const string = value
        .replace(/\r\n?/g, '\n')
        .replace(/(\n{2})+/g, '</p><p>')
        .replace(/\n/g, '<br>');

    return `<p>${string}</p>`;
}
